<template>
  <div class="row mw-100 d-flex justify-content-center">
    <div class="col d-flex justify-content-center">
      <div class="header">
        <h1 class="text-poppins">
          Track Created!
        </h1>

        <p>
          We got your files and will prep them for mix. If we need anything from
          you, we will reach out and make sure we get it right.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.text-poppins {
  font-family: "Poppins", sans-serif !important;
}

h1 {
  color: #2bfed1;
}
</style>
